/*
  Copyright 2018 Experian. All Rights Reserved
*/

import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from '../../../core/helpers/globals';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: true,
    imports: [NgIf]
})
export class LoaderComponent  implements OnDestroy {

  globalSubscription: Subscription;
  showLoading = false;

  constructor(private globals: Globals) {
    this.globalSubscription = this.globals.showLoading.subscribe(
      activeItems => {
        this.showLoading = activeItems.length > 0;
      });
  }

  ngOnDestroy() {
    this.globalSubscription.unsubscribe();
  }

}
